import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import MainLayout from "../../Layouts/Main_Layout";
import Header from "../../Header/header";
import HeaderMenu from "../../Header/header-menu";
import Isi from "../../ISI/Isi";
import IsiFrame from '../../ISI/Isi-frame';
import Footer from "../../Footer/Footer";
import './Unsubscribe.css'

export default function UnSubscribePage() {
  const navigate = useNavigate();
  const myRef = useRef(null)
  const [show, setShow] = useState(true)
  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }

  useEffect(() => {
    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset)
    return () => { window.removeEventListener('resize', calculateOffset) };
  }, []);
    
  return (
    <MainLayout>
      <div className="unsubscribe">
        <Helmet>
          <title>Unsubscribe Confirmation | INBRIJA® (levodopa inhalation powder)</title>
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className="hero-section">
            <div className="container">
              <h1>Unsubscribe</h1>
            </div>
          </div>
        </HeaderMenu>
        <div className="brush-style"></div>

        <div className="unsubscribe-confirmation-container container">
          <h2>You've unsubscribed</h2>
          <p>We are sorry to see you go. Please allow 24 &mdash; 48 hours for the request to propagate through all systems. If this was done in mistake, please <a onClick={() => navigate('/sign-up')} className="link">sign up</a> again.</p>
          <a onClick={() => navigate('/')} className="btn">Go To Home Page</a>
        </div>
        <div ref={myRef}>
          <Isi />
        </div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}
        <Footer
          partNum="6/2024 US-INB-2400004"
          year="2025"
          twitterCode="https://twitter.com/intent/tweet?text=Learn%20more%20about%20INBRIJA.%20INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more.%20https://www.inbrija.com"
          facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2F&title=Learn%20more%20about%20INBRIJA&description=INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more." />
      </div>
    </MainLayout>
  )
}